'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/inline-style-prefixer/lib/plugins/backgroundClip.js
// module id = 18
// module chunks = 0